import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Bunu ekledik
import { HiMenuAlt3, HiX } from "react-icons/hi";
import LogoDark from "../assets/img/balatlogo.png";
import LogoWhite from "../assets/img/balatlogo.png";

const Header = () => {
  const [header, setHeader] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const location = useLocation(); // Mevcut yolu alıyoruz

  useEffect(() => {
    const handleScroll = () => {
      setHeader(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // EĞER ana sayfada değilsek, header HER ZAMAN beyaz arka planlı olsun
  const isHomePage = location.pathname === "/";
  const headerActive = header || !isHomePage;

  const changeLang = (lang) => {
    document.cookie = `googtrans=/tr/${lang}; path=/`;
    const attemptChange = () => {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
        select.value = lang;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        window.location.reload(); 
      } else {
        setTimeout(attemptChange, 500);
      }
    };
    attemptChange();
  };

  const navLinks = [
    { name: "ANASAYFA", href: "/" },
    { name: "ODALAR", href: "/#odalar" },
    { name: "İLETİŞİM", href: "/contact" },
    { name: "HAKKIMIZDA", href: "/about" },
  ];

  return (
    <header
      className={`${
        headerActive ? "bg-white py-4 shadow-lg" : "bg-transparent py-6"
      } fixed z-50 w-full transition-all duration-500`}
    >
      <div className="container mx-auto flex items-center justify-between px-4">
        <a href="/" className="flex-shrink-0">
          {/* Logo rengini de duruma göre ayarlıyoruz */}
          <img
            src={headerActive ? LogoDark : LogoWhite}
            alt="Logo"
            className="h-10 lg:h-12"
          />
        </a>

        <nav
          className={`${
            headerActive ? "text-primary" : "text-white"
          } hidden lg:flex gap-x-8 font-tertiary tracking-[3px] text-[15px] items-center`}
        >
          {navLinks.map((link, index) => (
            <a key={index} href={link.href} className="hover:text-accent transition">
              {link.name}
            </a>
          ))}
          <button onClick={() => changeLang("en")} className="ml-4 focus:outline-none">
            <img src="//ademcakir.com.tr/wp-content/plugins/gtranslate/flags/24/en.png" alt="English" className="w-6 h-6" />
          </button>
        </nav>

        {/* Mobil İkon Rengi */}
        <div
          onClick={() => setMobileNav(!mobileNav)}
          className={`${headerActive ? "text-primary" : "text-white"} lg:hidden cursor-pointer text-3xl`}
        >
          {mobileNav ? <HiX /> : <HiMenuAlt3 />}
        </div>

        {/* Mobil Menü her zaman beyaz kalabilir */}
        <nav
          className={`${
            mobileNav ? "max-h-max py-8 px-4" : "max-h-0"
          } flex flex-col w-full bg-white fixed top-[72px] left-0 right-0 overflow-hidden transition-all duration-300 lg:hidden shadow-xl font-tertiary font-medium tracking-[2px]`}
        >
          <div className="flex flex-col gap-y-6 items-center">
            {navLinks.map((link, index) => (
              <a key={index} href={link.href} onClick={() => setMobileNav(false)} className="text-primary hover:text-accent transition text-lg">
                {link.name}
              </a>
            ))}
            <button onClick={() => { changeLang("en"); setMobileNav(false); }}>
              <img src="//ademcakir.com.tr/wp-content/plugins/gtranslate/flags/24/en.png" alt="English" className="w-6 h-6" />
            </button>
          </div>
        </nav>
      </div>
      <div id="google_translate_element" style={{ visibility: 'hidden', position: 'absolute' }}></div>
    </header>
  );
};

export default Header;